import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group">
            <div className="text-xl md:text-2xl font-bold">
              <span className="text-[#4ade80]">Capital</span>
              <span className="text-white"> Property Improvements</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-[#4ade80] ${
                  location.pathname === link.path
                    ? 'text-[#4ade80]'
                    : 'text-gray-300'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:07738965968"
              className="flex items-center space-x-2 text-sm text-gray-300 hover:text-[#4ade80] transition-colors"
            >
              <Phone size={16} />
              <span>07738 965 968</span>
            </a>
            <Button
              asChild
              className="bg-[#4ade80] hover:bg-[#22c55e] text-black font-semibold"
            >
              <Link to="/contact">Get Quote</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-md border-t border-gray-800">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-base font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'text-[#4ade80]'
                    : 'text-gray-300 hover:text-[#4ade80]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 space-y-3 border-t border-gray-800">
              <a
                href="tel:07738965968"
                className="flex items-center space-x-2 text-gray-300 hover:text-[#4ade80]"
              >
                <Phone size={18} />
                <span>07738 965 968</span>
              </a>
              <a
                href="mailto:cpi-leics@outlook.com"
                className="flex items-center space-x-2 text-gray-300 hover:text-[#4ade80]"
              >
                <Mail size={18} />
                <span>cpi-leics@outlook.com</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;